import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { InstallationsService } from 'src/app/services/http/installations/installations.service';
import { RatesBreakdownComponent } from '../rates-breakdown/rates-breakdown.component';


@Component({
  selector: 'app-rates-view',
  templateUrl: './rates-view.component.html',
  styleUrls: ['./rates-view.component.scss']
})
export class RatesAllComponent implements OnInit {

  @Input() machine : any;

  get displayedColumn(): string[] {
    const result: string[] = ['annee', 'mois', 'installations', 'defaillances', 'tauxFiabilite'];
    return result;
  }

  constructor(private service : InstallationsService, public dialog : MatDialog) { }
  
  //public installations! : Installations;
  public rates! : any[]; 

  ngOnInit(): void {
    this.service.getRates()
    .subscribe( (rates) => {
        this.rates = rates[this.machine];
    });
  }

  public getPreviousMonth( currentRate: any) : string{
    let currentIndex = this.rates.findIndex(rate => rate.month === currentRate.month && rate.year == currentRate.year);
    if(currentIndex + 1 <  this.rates.length){
      return this.rates[currentIndex +1].installs;
    } else {
      return 'N/A';
    }
    
  }

  public getTotalInstalls(currentRate: any): string {
    let prev = Number(this.getPreviousMonth( currentRate ));
    if( isNaN( prev ) ){
      return 'N/A';
     }

    return String(prev + +currentRate.installs);
  }

  public getTaux(rate : any) : string {
    let nbPrev = Number( this.getTotalInstalls(rate) );

    let taux = 1 - Number(rate.inters) / nbPrev;

    return this.roundToTwo(taux).toString(); // + ' - ' +  taux.toString();
  }

  private roundToTwo( num : number): number {    
    return Math.round( ( num + Number.EPSILON ) * 100 ) / 100;
}

  public showBreakdown(rate: any){
    let month;
    if(rate.month < 10) { // Convert 2022-1 to 2022-01
      month = String(rate.year + '-' + String('00' + rate.month).slice(-2));
    } else {
      month = String(rate.year + '-' + rate.month);
    }
    console.log(month)
    this.service.getRateBreakdown(month, this.machine).subscribe( (monthly) => {
      this.dialog.open(RatesBreakdownComponent,{
        data: {
          month : monthly
        }
      });
    });

  }

}
